(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-post"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function () {
		var article = document.querySelector('.article__content .rte[itemprop="articleBody"]');
		// There can be up to two TOC copies in the DOM: one inside the sidebar
		// (desktop) and one placed right under the banner (mobile). Both get
		// populated; CSS decides which one is actually shown at a given width.
		var tocLists = document.querySelectorAll('.article-toc__list');
		if (!article || !tocLists.length) return;

		var headings = article.querySelectorAll('h2, h3');
		if (!headings.length) {
			document.querySelectorAll('.article-toc').forEach(function (el) {
				el.style.display = 'none';
			});
			return;
		}

		var isDesktop = window.matchMedia('(min-width: 992px)').matches;
		var desktopDetails = document.querySelector('.article-toc--desktop .article-toc__details');
		if (desktopDetails && isDesktop) desktopDetails.open = true;

		var usedIds = {};
		headings.forEach(function (heading) {
			if (!heading.id) {
				var base = heading.textContent.trim().toLowerCase()
					.replace(/[^a-z0-9\s-]/g, '')
					.replace(/\s+/g, '-') || 'section';
				var id = base;
				var counter = 1;
				while (usedIds[id]) { id = base + '-' + counter++; }
				usedIds[id] = true;
				heading.id = id;
			} else {
				usedIds[heading.id] = true;
			}
		});

		tocLists.forEach(function (list) {
			headings.forEach(function (heading) {
				var li = document.createElement('li');
				li.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();
				var link = document.createElement('a');
				link.href = '#' + heading.id;
				link.textContent = heading.textContent.trim();
				link.className = 'article-toc__link';
				link.setAttribute('data-toc-target', heading.id);
				li.appendChild(link);
				list.appendChild(li);
			});
		});

		var allLinks = document.querySelectorAll('.article-toc__link');

		allLinks.forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var target = document.getElementById(link.getAttribute('data-toc-target'));
				if (!target) return;
				var offset = window.matchMedia('(min-width: 992px)').matches ? 100 : 80;
				var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
				window.scrollTo({ top: top, behavior: 'smooth' });
				if (!window.matchMedia('(min-width: 992px)').matches) {
					var openDetails = link.closest('details');
					if (openDetails) openDetails.open = false;
				}
			});
		});

		if ('IntersectionObserver' in window) {
			var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					var matchingLinks = document.querySelectorAll('[data-toc-target="' + entry.target.id + '"]');
					if (!matchingLinks.length) return;
					if (entry.isIntersecting) {
						allLinks.forEach(function (l) { l.classList.remove('is-active'); });
						matchingLinks.forEach(function (l) { l.classList.add('is-active'); });
					}
				});
			}, { rootMargin: '-20% 0px -70% 0px' });

			headings.forEach(function (heading) { observer.observe(heading); });
		}
	});

  } catch(e) { console.error(e); }
})();
})();
